<template>
  <div class="annual">
    <van-overlay class="loading" :show="show" >
      <div class="wrapper">
        <van-loading color="#0094ff" text-color="#0094ff" size="24px" vertical>数据准备中...</van-loading>
      </div>
    </van-overlay>
    <swiper style="z-index: 100;" v-if="showSwiper" :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-if="annualData.is_customized" class="swper">
        <div ref="swiper1" class="page">
          <img src="./images/swiper1.png">
          <div class="text-detail-text1">
            <div>一切要从<span>{{ annualData.first_login_date }}</span>说起</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="annualData.is_customized && annualData.first_circle_text.trim().length > 0" class="swper">
        <div ref="swiper2" class="page">
          <img src="./images/swiper2.png">
          <div class="text-detail-text2">
            <div v-html="annualData.first_circle_text"></div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="annualData.received_star_cnt > 0 && annualData.is_customized" class="swper">
        <div ref="swiper3" class="page">
          <img src="./images/swiper3.png">
          <div class="text-detail-text3">
            <div>今年你一共收到了 <span>{{ annualData.received_star_cnt }}</span> 个赞评</div>
            <div>有 <span>{{ annualData.received_star_user_cnt }}</span> 个复星仁儿赞同了你</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide  v-if="annualData.delivered_star_cnt > 0 && annualData.is_customized" class="swper">
        <div ref="swiper4" class="page">
          <img src="./images/swiper4.png">
          <div class="text-detail-text4">
            <div>今年</div>
            <div>你总共送出了{{ annualData.delivered_star_cnt }}个赞评</div>
            <div>是一种惺惺相惜的仪式感</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="annualData.hot_circle_cnt > 0 && annualData.is_customized" class="swper">
        <div ref="swiper5" class="page">
          <img src="./images/swiper5.png">
          <div class="text-detail-text5">
            <div>今年你参与了 <span>{{ annualData.hot_circle_cnt }}</span> 次热门话题讨论</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="annualData.is_customized" class="swper">
        <div ref="swiper6" class="page">
          <img src="./images/swiper6.png">
          <div class="text-detail-text6">
            <div>今年你总共登录星圈 <span>{{ annualData.login_pv_cnt }}</span> 次</div>
            <div>星圈一共陪你度过了 <span>{{ annualData.accompany_days }}</span> 天</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="annualData.is_customized" class="swper">
        <div ref="swiper7" class="page">
          <img src="./images/swiper7.png">
          <div class="text-detail-text7">
            <!-- <div>今年</div> -->
            <div v-if="annualData.post_circle_cnt > 1">你是星圈年度社交王者</div>
            <div v-else-if="annualData.delivered_star_cnt > annualData.delivered_avg_star_cnt" >你是星圈的气氛组担当</div>
            <div v-else>你是星圈的10G冲浪选手</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="!annualData.is_customized" class="swper">
        <div ref="swiper8" class="page">
          <img src="./images/swiper8.png">
          <div class="text-detail-text9">
            <!-- <div><span>2022</span>年</div>
            <div>你还没有在星圈发布过任何实名帖子,</div>
            <div><span>2023</span>年还请踊跃参与哦</div> -->
            <div>2023年</div>
            <div>星圈最火爆的热门话题是 <span>我有话要说</span> 总共得到了 <span>{{annualData.top_star_cnt}}</span> 个赞评,收获了不少有意义的“吐槽”。</div>
            <div>其中 <span>{{ annualData.top_star_username }}</span> 的帖子 「{{annualData.top_star_circle_text}}」 点赞最高，得到了非常多的共鸣。</div>
          </div>
        </div>
      </swiper-slide>
      <!-- <swiper-slide v-if="!annualData.is_customized" class="swper">
        <div ref="swiper9" class="page">
          <img src="./images/swiper6.png">
          <div class="text-detail-text8">
          </div>
        </div>
      </swiper-slide> -->
      <swiper-slide v-if="!annualData.is_customized" class="swper">
        <div ref="swiper9" class="page">
          <img src="./images/swiper9.png">
          <div class="text-detail-text11">
            <!-- <div>2022年</div>
            <div>星圈进行了改版，在星圈-圈子 建设了 <span>星知乎</span> 专区，专属复星仁儿的 <span>人事</span> 问答专区，只为更好的服务复星仁儿。</div> -->
          </div>
        </div>
      </swiper-slide>
      <!-- <swiper-slide v-if="!annualData.is_customized" class="swper">
        <div ref="swiper9" class="page">
          <img src="./images/swiper4-1.png">
          <div class="text-detail-text10">
            <div>2022年底</div>
            <div>星圈与智能科技条线合作上线:</div>
            <div><span>复星战疫互助平台</span></div>
            <div> 旨在给复星同学提供更多内部互助渠道。你可在平台上，帮助复星大家庭里的同学，若遇到困难，也请在平台上留下你的需求，截止目前该平台上的帮助次数已达到 <span>248</span> 次。</div>
          </div>
        </div>
      </swiper-slide> -->
      <!-- <swiper-slide class="swper">
        <div ref="swiper10" class="page">
          <img src="./images/swiper7.png">
        </div>
      </swiper-slide> -->
    </swiper>
    <!-- <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide class="swper" v-for="(item,index) in Images" :key="index">
        <div ref="swiper1" class="page">
          <img :src="item">
        </div>
      </swiper-slide>
    </swiper> -->
    <!-- <img v-show="!isShowDown" class="down" src="./images/logo.png"> -->
    <img class="down" v-show="!isShowDown" src="./images/logo.png">
    <!-- <div class="download">截图保存</div> -->
    <!-- <img @click="download" class="download" src="./images/download.svg"> -->
  </div>
</template>

<script>
import { get } from '../../utils/token'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { getaAnnualSummary } from '../../api/api'
import { getJpeg } from '../../utils/getDomJpeg'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {},
  data () {
    return {
      show: true,
      showSwiper: true,
      Images: [],
      pages: 6,
      mobile: get('mobile'),
      beforeSlideIndex: 0,
      // 记录当前swiper的activeIndex
      thisActiveIndex: 0,
      annualData: {},
      swiperOption: {
        effect: 'fade',
        direction: 'vertical',
        autoplay: false,
        height: window.innerHeight,
        width: window.innerWidth,
        speed: 0,
        on: {
          slideChange: () => {
            // debugger;
            const swiper = this.$refs.mySwiper.$swiper
            const slideIndex = swiper.activeIndex
            this.thisActiveIndex = slideIndex
          }
        }
      }
    }
  },
  computed: {
    isShowDown () {
      return this.annualData.delivered_star_cnt > 0 && this.thisActiveIndex === 2
      //  this.thisActiveIndex === this.pages
    },
    isShow () {
      return JSON.stringify(this.annualData) !== '{}'
    },
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  created () { },
  mounted () {
    this.getData()
  },
  methods: {
    // 加工为图片
    async setImages () {
      for (let i = 1; i < 11; i++) {
        if (this.$refs[`swiper${i}`]) {
          const data = await getJpeg(this.$refs[`swiper${i}`])
          this.Images.push(data)
        }
      }
      this.showSwiper = false
    },
    async download () {
      const data = await getJpeg(this.$refs.swiper6)
      var link = document.createElement('a')
      link.href = data
      link.download = '我的个人年报.png'
      link.click()
    },
    async getData () {
      const res = await getaAnnualSummary(this.mobile)
      if (res.code === 200) {
        this.annualData = res.data
        if (this.annualData.received_star_cnt < 1) {
          this.pages -= 1
        }
        if (this.annualData.delivered_star_cnt < 1) {
          this.pages -= 1
        }
        if (this.annualData.hot_circle_cnt < 1) {
          this.pages -= 1
        }
      }
      if (!this.annualData.is_customized) {
        this.pages = 3
      }
      setTimeout(() => {
        this.show = false
      }, 2000)
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
@-webkit-keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-4px);
  }

  50%,
  100% {
    -webkit-transform: translateY(0);
  }

  75% {
    -webkit-transform: translateY(4px);
  }
}

@keyframes bounce-down {
  25% {
    transform: translateY(-4px);
  }

  50%,
  100% {
    transform: translateY(0);
  }

  75% {
    transform: translateY(4px);
  }
}
  .annual {
    font-size: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    img {
      pointer-events: none;
    }
    .loading {
      display: flex;
      align-items: center;
      background-color: #fff;
      z-index: 200;
      justify-content: space-around;
    }

    .down {
      position: absolute;
      bottom: 15px;
      z-index: 100;
      width: 100px;
      left: 50%;
      margin-left: -50px;
      // animation: bounce-down 1.6s linear infinite;
    }
    .download {
      position: absolute;
      bottom: 20px;
      z-index: 100;
      right: 50px;
      font-size: 12px;
      color: #848181;
    }
  }

  .swper {
    width: 100vw;
    height: 100vh;
    color: #541e07;

    .page {
      display: flex;
      justify-content: space-around;
      align-items: center;
      position: relative;

      img {
        width: 100vw;
        height: 100vh;
        // object-fit: cover;
      }
      .text-detail-text11 {
        position: absolute;
        font-size: 18px;
        top: 200px;
        width: 85%;
        line-height: 30px;
        span {
          color: #ab6096;
          font-size: 22px;
          font-weight: 700;
        }
      }
      .text-detail-text10 {
        position: absolute;
        font-size: 18px;
        top: 60px;
        line-height: 30px;
        width: 83%;
        span {
          color: #ab6096;
          font-size: 22px;
          font-weight: 700;
        }
        & div:nth-child(4) {
          margin-top: 30px;
        }
      }
      .text-detail-text9 {
        position: absolute;
        font-size: 18px;
        left: 15%;
        width: 75%;
        line-height: 24px;
        span {
          color: #ab6096;
          font-size: 22px;
          font-weight: 700;
        }
        & div:nth-child(1) {
          span {
            font-size: 28px;
          }
        }
        & div:nth-child(3) {
          margin-bottom: 40px;
          span {
            font-size: 24px;
          }
        }
        & div:nth-child(5) {
          // margin-top: 40px;
          & span:nth-child(2) {
            font-size: 18px;
          }
        }
        & div:nth-child(6) {
          margin-top: 10px;
          // width: 70%;
          // margin-left: 10px;
          // font-size: 17px;
          line-height: 24px;
        }
      }
      .text-detail-text8 {
        position: absolute;
        font-size: 18px;
        top: 40px;
        width: 80%;
        line-height: 24px;
        span {
          color: #ab6096;
          font-size: 22px;
          font-weight: 700;
        }
        div {
          margin: 10px 0;
        }
      }

      .text-detail-text7 {
        position: absolute;
        font-size: 24px;
        top: 33%;
        left: 13%;
        text-align: end;
        color: #fff;

        & div:nth-child(2) {
          margin: 15px 0 30px;
          font-size: 24px;
        }
      }

      .text-detail-text6 {
        position: absolute;
        font-size: 18px;
        top: 33%;
        left: 20%;
        color: #000;
        // transform: rotate(-7deg);

        & div:nth-child(1) {
          margin-bottom: 10px;
        }

        span {
          // color: #ab6096;
          // font-size: 28px;
          font-weight: 700;
        }
      }

      .text-detail-text5 {
        position: absolute;
        font-size: 18px;
        width: 205px;
        top: 20%;
        color: #000;
        & div:nth-child(1) {
          margin-top: 50px;
          span {
            // font-size: 28px;
            // font-weight: 700;
          }
        }
      }

      .text-detail-text4 {
        position: absolute;
        font-size: 18px;
        bottom: 25%;
        color: #000;
        left: 5%;

        & div:nth-child(2) {
          margin: 10px 0 10px;
          font-size: 20px;
        }
      }

      .text-detail-text3 {
        position: absolute;
        font-size: 18px;
        color: #fff;
        top: 20%;

        span {
          font-size: 24px;
          font-weight: 700;
        }

        & div:nth-child(1) {
          margin-bottom: 40px;
        }

        & div:nth-child(2) {
          margin-left: 40px;
        }
      }

      .text-detail-text2 {
        position: absolute;
        color: #000;
        line-height: 30px;
        font-size: 20px;
        width: 180px;
        height: 145px;
        top: 45%;
        left: 20%;
        div {
          width: 100%;
          height: 100%;
          word-wrap: break-word;
          -webkit-line-clamp: 5;
          // position: relative;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }

      .text-detail-text1 {
        position: absolute;
        font-size: 16px;
        left: 25%;
        bottom: 40%;
        color: #000;
        font-size: 18px;
        transform: rotate(-18deg);

        span {
          font-size: 22px;
          font-weight: 700;
        }

        & div:nth-child(1) {
          margin-bottom: 40px;
        }

        & div:nth-child(2) {
          font-size: 18px;
          font-weight: 700;
        }
      }

    }
  }
</style>
